"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JustCarousel = void 0;
const react_1 = __importStar(require("react"));
const react_spring_1 = require("react-spring");
const react_use_gesture_1 = require("react-use-gesture");
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const createGetMoveState_1 = require("./createGetMoveState");
const createGetSlideAnimateState_1 = require("./createGetSlideAnimateState");
const createGetSliderState_1 = require("./createGetSliderState");
const useAuto_1 = __importDefault(require("./useAuto"));
const JustCarouselWrapper = styled_components_1.default.section({
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
}, ({ ratio }) => ({
    paddingTop: `${100 * Number(ratio)}%`,
}));
const CarouselSlider = (0, styled_components_1.default)(react_spring_1.animated.ul).attrs({
    className: `slider`,
})({
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    bottom: 0,
});
const CarouselSlide = (0, styled_components_1.default)(react_spring_1.animated.li).attrs({
    className: `slide`,
})({
    position: 'absolute',
    userSelect: 'none',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    boxShadow: '0 62.5px 125px -25px rgba(50, 50, 73, 0.5), 0 37.5px 75px -37.5px rgba(0, 0, 0, 0.6)',
    img: {
        pointerEvents: 'none',
    },
    pointerEvents: 'none',
});
const SlideIcon = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs({
    name: `chevron-big-left`,
})({
    position: 'absolute',
    width: '30px',
    height: '97px',
    top: '50%',
    color: 'white',
    filter: 'drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.5))',
    cursor: 'pointer',
    transition: 'filter',
    zIndex: 3,
    ':active': {
        filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.5))',
    },
});
const SlideLeftIcon = (0, styled_components_1.default)(SlideIcon).attrs({
    className: `slide-left`,
    testId: `left`,
})({
    transform: 'translateY(-50%)',
    left: '40px',
    ':hover': {
        transform: 'translateY(-50%) scale(1.1)',
    },
});
const SlideRightIcon = (0, styled_components_1.default)(SlideIcon).attrs({
    className: `slide-right`,
    testId: `right`,
})({
    transform: 'rotateY(180deg) translateY(-50%)',
    right: '40px',
    ':hover': {
        transform: 'rotateY(180deg) translateY(-50%) scale(1.1)',
    },
});
function JustCarousel(props) {
    const { className, ratio = 0.5, scaling = true, chevrons = true, sliding = true, items, renderItem, autoSlide, } = props;
    const dragging = sliding && props.dragging !== false;
    const count = items.length;
    const wrapperRef = (0, react_1.useRef)(null);
    const [measureRef, { width }] = (0, react_use_measure_1.default)();
    const { isOnScreen } = (0, libs_hooks_dom_1.useOnScreen)(wrapperRef);
    const isAppActive = (0, libs_hooks_dom_1.useIsAppActive)();
    const ref = (node) => {
        node && measureRef(node);
        wrapperRef.current = node;
    };
    const shift = (0, react_1.useRef)({ mx: 0, sc: 1, scTarget: -1 });
    const [state, setState] = (0, react_1.useState)({
        curr: 0,
        prev: 0,
        dir: 0,
    });
    const slideLeft = (0, react_1.useCallback)(() => {
        shift.current.scTarget = -1;
        shift.current.mx = 0;
        setState(prevState => ({
            prev: prevState.curr,
            curr: (prevState.curr - 1 + count) % count,
            dir: -1,
        }));
    }, [count]);
    const slideRight = (0, react_1.useCallback)(() => {
        shift.current.scTarget = -1;
        shift.current.mx = 0;
        setState(prevState => ({
            prev: prevState.curr,
            curr: (prevState.curr + 1) % count,
            dir: 1,
        }));
    }, [count]);
    const auto = (0, useAuto_1.default)(slideRight, count > 1 ? autoSlide : undefined);
    const getMoveState = (0, react_1.useMemo)(() => (0, createGetMoveState_1.createGetMoveState)(count), [count]);
    const getSlideState = (0, react_1.useMemo)(() => (0, createGetSliderState_1.createGetSliderState)(count, width), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [count, width]);
    const getSlideAnimateState = (0, react_1.useMemo)(() => (0, createGetSlideAnimateState_1.createGetSlideAnimateState)(count, width), [count, width]);
    const [springs, api] = (0, react_spring_1.useSprings)(count, sliding
        ? (i) => {
            const { mx, sc: memSc, scTarget } = shift.current;
            const { from: fromX, to, isActive } = getSlideAnimateState(state, i, mx);
            const sc = scaling && scTarget === i ? memSc : 1;
            // from is set only for slide buttons
            // target slide is already in place on dragging events
            const from = mx === 0
                ? { visible: true, x: fromX, sc, immediate: true }
                : undefined;
            return isActive
                ? {
                    from,
                    to: [from, { x: to, sc: 1 }],
                }
                : { visible: false, x: to, sc, immediate: true };
        }
        : (i) => {
            return {
                from: { visible: state.prev === i, o: state.prev === i ? 1 : 0 },
                to: { visible: state.curr === i, o: state.curr === i ? 1 : 0 },
            };
        }, [width, state]);
    const bind = (0, react_use_gesture_1.useDrag)(({ down, movement: [mx], distance, cancel, first, canceled }) => {
        if (canceled)
            return;
        const { dir, targetIndex } = getMoveState(state, mx);
        if (first) {
            auto.stop();
        }
        if (down && distance > width / 3) {
            const currentX = api.stop().current[state.curr].get().x;
            // save shift x axis movement
            shift.current.mx = currentX;
            cancel();
            setState(prevState => ({
                prev: prevState.curr,
                curr: targetIndex,
                dir,
            }));
            auto.start();
            return;
        }
        api.start(i => {
            const { isActive, isCurrentSlide, baseX } = getSlideState(state, i, mx);
            const sc = scaling && isCurrentSlide && down ? 1 - distance / width / 5 : 1;
            // remember scale
            if (sc < 1) {
                shift.current.sc = sc;
                shift.current.scTarget = i;
            }
            return {
                visible: isActive,
                x: down ? baseX + mx : baseX,
                sc,
                immediate: first,
                // immediate: true,
            };
        });
    }, {
        axis: 'x',
        useTouch: true,
        enabled: count > 1 && dragging,
    });
    return (react_1.default.createElement(JustCarouselWrapper, { className: `carousel-wrapper ${className}`, ref: ref, ratio: ratio },
        react_1.default.createElement(CarouselSlider, Object.assign({}, bind()), springs.map(({ visible, x, o, sc }, index) => (react_1.default.createElement(CarouselSlide, { key: index, style: {
                display: sliding && visible.get() === false && index !== state.curr
                    ? 'none'
                    : 'flex',
                left: sliding ? x === null || x === void 0 ? void 0 : x.to(v => `${v}px`) : 0,
                opacity: sliding ? undefined : o === null || o === void 0 ? void 0 : o.to(v => `${v}`),
                transform: scaling ? sc === null || sc === void 0 ? void 0 : sc.to(v => `scale(${v})`) : undefined,
                zIndex: index === state.curr ? 1 : 0,
            } }, renderItem(items[index], index, {
            visible: isAppActive && isOnScreen && index === state.curr,
        }, auto))))),
        chevrons && count > 1 ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SlideLeftIcon, { onClick: slideLeft, "aria-label": `Previous slide` }),
            react_1.default.createElement(SlideRightIcon, { onClick: slideRight, "aria-label": `Next slide` }))) : null));
}
exports.JustCarousel = JustCarousel;
//# sourceMappingURL=index.js.map